// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message.
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from "../runtime";
import { ProjectMini, ProjectMiniFromJSON, ProjectMiniToJSON } from "./";

/**
 * For setting_type review, review_groups_enabled is \"1\" to enable saved reviewer groups or \"0\" to disable them (the default). It is configurable only while review is enabled. default_reviewer_group stores an active reviewer group ID from this project as a string; an empty value clears it. It is configurable when review is enabled. With mandatory review, the UI pre-fills this group on add/edit/bulk edit when there is no explicit selection or existing assignment. Individual default settings retain their existing meaning.
 * @export
 * @interface Projectsetting
 */
export interface Projectsetting {
  /**
   *
   * @type {string}
   * @memberof Projectsetting
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof Projectsetting
   */
  value: string;
  /**
   *
   * @type {string}
   * @memberof Projectsetting
   */
  label?: string;
  /**
   *
   * @type {ProjectMini}
   * @memberof Projectsetting
   */
  project?: ProjectMini;
}

export function ProjectsettingFromJSON(json: any): Projectsetting {
  return {
    name: json["name"],
    value: json["value"],
    label: !exists(json, "label") ? undefined : json["label"],
    project: !exists(json, "project")
      ? undefined
      : ProjectMiniFromJSON(json["project"]),
  };
}

export function ProjectsettingToJSON(value?: Projectsetting): any {
  if (value === undefined) {
    return undefined;
  }
  return {
    name: value.name,
    value: value.value,
    label: value.label,
    project: ProjectMiniToJSON(value.project),
  };
}
